(function() { window.GUID_533c236f_94f2_468a_949e_64b275d05d87 = { getGuid: function() { return "533c236f-94f2-468a-949e-64b275d05d87"; } }; })();
CompuSport.DOM.body.on('click', '.SetWinner', function (e) {
    var data = {
        elementToRefresh: 'ScheduleItem',
        encounterRowId: $(this).data('encounterrowid')
    };
    ShowSchedulesScorePopup(data);
});
function ShowSchedulesScorePopup(data) {
    CompuSport.Ajax.Get(CSParameters.RUrl + 'Scores/CheckIsNewScoreSheet/' + CSParameters.SportEventId, data, function (response) {
        if (response.isNewScoreSheet) {
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: 'ScorePopup',
                Url: CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPosted = function (response) {
                //UpdateChart(response, true);
            };
        }
        else {
            /*
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "ScorePopup",
                Url: CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPosted = function (response) {
                UpdateChart(response, true);
            }
            */
            ShowFormPopup(CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId, data, null, function (response, pressedButton) {
                if (pressedButton != "EnterKey") {
                    //UpdateChart(response, true);
                    $(this).dialog('close');
                }
            });
        }
    });
}

//# sourceMappingURL=Schedules.js.map
